var render = function (_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    { staticStyle: { padding: "30px" } },
    [
      _c("el-alert", {
        attrs: { closable: false, title: "menu 1-3", type: "success" },
      }),
      _vm._v(" "),
      _vm._l(100, function (n) {
        return [_vm._v("\n    测试"), _c("br")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }